export default __webpack_public_path__ + "static/media/1718 knife block A side.d78df087.png";